import { DateFilterDto, DateFilterOperator } from "@tfg/ui"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"

import { formatDate } from "~/utils/date"

export const useFiltersOperatorsLabelsTranslations = () => {
  const { t } = useTranslation(["common"])

  return {
    [DateFilterOperator.between]: t("table.dateFilter.operator.between"),
    [DateFilterOperator.equals]: t("table.dateFilter.operator.equals"),
    [DateFilterOperator.before]: t("table.dateFilter.operator.before"),
    [DateFilterOperator.after]: t("table.dateFilter.operator.after"),
    [DateFilterOperator.empty]: t("table.dateFilter.operator.empty"),
    [DateFilterOperator.notEmpty]: t("table.dateFilter.operator.notEmpty"),
    [DateFilterOperator.notEquals]: t("table.dateFilter.operator.notEquals"),
    [DateFilterOperator.beforeOrEquals]: t(
      "table.dateFilter.operator.beforeOrEquals"
    ),
    [DateFilterOperator.afterOrEquals]: t(
      "table.dateFilter.operator.afterOrEquals"
    ),
    [DateFilterOperator.notBetween]: t("table.dateFilter.operator.notBetween"),
  }
}

export type FiltersOperatorsValuesResolver = (filter: DateFilterDto) => string

export const useFiltersOperatorsValuesResolver =
  (): FiltersOperatorsValuesResolver => {
    const { t } = useTranslation(["common"])

    const labelResolver = useCallback(
      (filter: DateFilterDto) => {
        const { startDate, endDate, operator } = filter

        const formattedStartDate = startDate ? formatDate(startDate) : ""
        const formattedEndDate = endDate ? formatDate(endDate) : ""

        const formattedDates =
          formattedStartDate && formattedEndDate
            ? `${formattedStartDate} - ${formattedEndDate}`
            : formattedStartDate || formattedEndDate

        const labelResolver = {
          [DateFilterOperator.between]: `${t("table.dateFilter.operator.between")} ${formattedDates}`,
          [DateFilterOperator.equals]: `${t("table.dateFilter.operator.equals")} ${formattedStartDate}`,
          [DateFilterOperator.before]: `${t("table.dateFilter.operator.before")} ${formattedStartDate}`,
          [DateFilterOperator.after]: `${t("table.dateFilter.operator.after")} ${formattedStartDate}`,
          [DateFilterOperator.notEquals]: `${t("table.dateFilter.operator.notEquals")} ${formattedStartDate}`,
          [DateFilterOperator.beforeOrEquals]: `${t("table.dateFilter.operator.beforeOrEquals")} ${formattedStartDate}`,
          [DateFilterOperator.afterOrEquals]: `${t("table.dateFilter.operator.afterOrEquals")} ${formattedStartDate}`,
          [DateFilterOperator.notBetween]: `${t("table.dateFilter.operator.notBetween")} ${formattedDates}`,
          [DateFilterOperator.notEmpty]: t(
            "table.dateFilter.operator.notEmpty"
          ),
          [DateFilterOperator.empty]: t("table.dateFilter.operator.empty"),
        }

        return labelResolver[operator]
      },
      [t]
    )

    return labelResolver
  }
